import { TourStatus } from '@/features/dashboard/tours/types/TourStatus.ts';
import { StatusTone } from '@/components/ui/statusTone.ts';

export const tourStatusUtils = {
  getLabel: (status: TourStatus): string => {
    return statusConfig[status]?.label;
  },

  getTooltip: (status: TourStatus): string => {
    return statusConfig[status]?.tooltip;
  },

  getTone: (status: TourStatus): StatusTone => {
    return statusConfig[status]?.tone;
  },

  getConfig: (status: TourStatus): TourStatusConfig => {
    return statusConfig[status];
  },
};

type TourStatusConfig = {
  label: string;
  tooltip: string;
  /** Barwy wylicza `StatusDot` z tonu — konfiguracja nie zna heksów. */
  tone: StatusTone;
};

export const statusConfig: Record<TourStatus, TourStatusConfig> = {
  [TourStatus.DRAFT]: {
    label: 'Szkic',
    tooltip: 'Dokończ konfigurację, aby wyjazd był widoczny dla klientów',
    tone: 'info',
  },
  [TourStatus.READY]: {
    label: 'Gotowy',
    tooltip: 'Wyjazd jest skonfigurowany',
    tone: 'success',
  },
  [TourStatus.CANCELLED]: {
    label: 'Anulowany',
    tooltip: 'Wyjazd został anulowany',
    tone: 'caution',
  },
  [TourStatus.ARCHIVED]: {
    label: 'Zarchiwizowany',
    tooltip: 'Wyjazd został zarchiwizowany i nie jest już aktywny',
    tone: 'neutral',
  },
};
